import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import {
  formatTimezoneDisplay,
  getAvailableTimezones,
  normalizeTimezoneForFormSelect,
} from '../utils/timezoneUtils';

export default function TimezoneSelect({
  value,
  onChange,
  label = 'Time zone',
  required = false,
  fullWidth = true,
  margin,
  size,
  helperText,
  disabled = false,
  error = false,
}) {
  const options = getAvailableTimezones();
  const selected = normalizeTimezoneForFormSelect(value);
  const known = options.map((tz) => tz.value);
  const showLegacy = selected && !known.includes(selected);

  return (
    <TextField
      select
      fullWidth={fullWidth}
      label={label}
      value={selected}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      margin={margin}
      size={size}
      helperText={helperText}
      disabled={disabled}
      error={error}
      SelectProps={{ native: false }}
    >
      {options.map((tz) => (
        <MenuItem key={tz.value} value={tz.value}>
          {tz.label}
        </MenuItem>
      ))}
      {showLegacy ? (
        <MenuItem value={selected}>{formatTimezoneDisplay(selected)}</MenuItem>
      ) : null}
    </TextField>
  );
}
